const baseURL = process.env.NEXT_PUBLIC_REVELRY_API_URL || process.env.REVELRY_API_URL

export const endpoints = {
  carts: `${baseURL}/flowerstore/carts`,
  cart: (id: string) => `${baseURL}/flowerstore/carts/${id}`,
  case: (id: string) => `${baseURL}/cases/${id}`,
  caseVisitorUserReactions: (caseID: number) => `${baseURL}/cases/${caseID}/visitor_user_reactions`,
  flowerstoreProducts: (facilityID: number | null) => {
    const url = `${baseURL}/flowerstore/products`
    const queryParams = facilityID ? `?facility_id=${facilityID}` : ''

    return url + queryParams
  },
  flowerstoreCalculateOrderTotal: (cartID: string) =>
    `${baseURL}/flowerstore/carts/${cartID}/order_totals`,
  flowerstoreDeliveryDates: `${baseURL}/flowerstore/delivery_dates`,
  flowerstoreGenerateToken: `${baseURL}/flowerstore/token`,
  flowerShoppingCartItems: (cartID: string) =>
    `${endpoints.cart(cartID)}/flower_shopping_cart_items`,
  deleteFlowerShoppingCartItem: (cartID: string, productID: string) =>
    `${endpoints.flowerShoppingCartItems(cartID)}/${productID}`,
  flowerstoreSubmitPayment: (id: string) => `${baseURL}/flowerstore/carts/${id}/payments`,
  funeralHome: `${baseURL}/funeral_homes`,
  memorialTrees: `${baseURL}/memorial_trees`,
  memorialTreeShoppingCartItems: (cartID: string) =>
    `${endpoints.cart(cartID)}/memorial_tree_shopping_cart_items`,
  deleteMemorialTreeShoppingCartItem: (cartID: string, productID: string) =>
    `${endpoints.memorialTreeShoppingCartItems(cartID)}/${productID}`,
  obituaries: `${baseURL}/v2/obituaries`,
  obituaryMemories: (caseID: number | string) => `${baseURL}/cases/${caseID}/obituary_memories`,
  obituaryMemory: (caseID: number | string, memoryID: number | string) =>
    `${baseURL}/cases/${caseID}/obituary_memories/${memoryID}`,
  obituaryMemoryComments: (obituaryMemoryID: number) =>
    `${baseURL}/obituary_memories/${obituaryMemoryID}/obituary_memory_comments`,
  obituarySnippets: `${baseURL}/v2/obituary_snippets`,
  reactions: `${baseURL}/reactions`,
  shoppingCarts: (shoppingCartID: string) => `${baseURL}/shopping_carts/${shoppingCartID}`,
  veteranContact: `${baseURL}/veteran_contacts`,
  visitorUsers: `${baseURL}/visitor_users`,
}
